import * as React from 'react';
import TableFilesPayRollIncident from './TableFilesPayRollIncident';
import EstatusLine from './EstatusLine';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import moment from "moment";
import { formatterMxn } from "../../../helpers/formatoMoneda";
import { GET_FILES_INCIDENT_PAYROLL } from '../../../Querys/querys';
import { useQuery } from '@apollo/client';

  function Row(props: { row :any}) {
    const { row } = props;
    const [filePayrollIncident, setFilePayrollIncident] = React.useState<Array<any>>([]);
    const [openDate, setOpenDate] = React.useState(false);  
    const [countFiles, setCountFiles] = React.useState(0);   
    const [openFile, setOpenFile] = React.useState(false);  
    const { data: filesPayrollIncident } = useQuery(GET_FILES_INCIDENT_PAYROLL, {
      variables: { idPayrollIncident:row.id  },
      fetchPolicy: 'no-cache'
    });
        
    React.useEffect(() => {

      if(filesPayrollIncident && filesPayrollIncident?.GET_FILES_INCIDENT_PAYROLL !==  null ){
        setFilePayrollIncident(filesPayrollIncident?.GET_FILES_INCIDENT_PAYROLL)
        setCountFiles(filesPayrollIncident?.GET_FILES_INCIDENT_PAYROLL.length)
       }
      }, [filesPayrollIncident]);  
    console.log(row)
    const d1 =moment(row.FechaGenerado)
    const d2 =moment(row.FechaFin)
    let fecha ="(1)"
    if(d2.diff(d1,'days') !== 0){
      fecha = `(${d2.diff(d1,'days')})`
    }

    return (
      <>
           <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> Sede</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.Sede}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'>{`Área o proyecto`}</span></TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.AreaProyecto}</span></TableCell> 
              </TableRow>             
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Categoría`}</span></TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.TipoConcepto}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Tipo`} </span></TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.TipoCobro}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Concepto`}</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.ConceptName}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row" ><span className='titlePayRollIncidentEnfasisDate'>{`Fechas seleccionadas (${row.Dias})`}</span> </TableCell>
                <TableCell align="right">         
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpenDate(!openDate)}
                    >
                    {openDate ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>            
                </TableCell>
                </TableRow>
                <TableRow >
                 <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2} >
                    <Collapse in={openDate} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                      {`${moment(row.FechaGenerado).utc().format('DD/MM/yyyy')} - ${moment(row.FechaFin).utc().format('DD/MM/yyyy')}`}
                    </Box>
                    </Collapse>
                 </TableCell>
              </TableRow>             
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Cantidad`}</span> </TableCell>
                {row.Tipo === 'Dinero' ?
                <TableCell align="right"><span className='infoPayRollIncident' >{row.Total ===0 ? '$0.00': formatterMxn(row.Total)}</span></TableCell> 
                :
                Number(row.horas) > 0 ?
                <TableCell align="right"  >                        
                    { `${row.horas} ` }{ row.horas !== 1 ? 'horas':'hora'}
                </TableCell>
                :
                <TableCell align="right">
                  { `${row.Dias} ` }{ row.Dias !== 1 ? 'días':'día'}
                </TableCell>
                }
              </TableRow>  
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Unidad`}</span> </TableCell>
                <TableCell align="right"><span className='infoPayRollIncident' >{row.Tipo}</span></TableCell> 
              </TableRow>
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncidentEnfasis'> {`Archivos Adjuntos (${countFiles})`} </span></TableCell>
                <TableCell align="right">         
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setOpenFile(!openFile)}
                    >
                    {openFile ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>            
                </TableCell>
              </TableRow> 
              <TableRow>
                 <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={2} >
                    <Collapse in={openFile} timeout="auto" unmountOnExit>
                    <Box sx={{ margin: 1 }}>
                       <TableFilesPayRollIncident filePayrollIncident={filePayrollIncident}/>
                    </Box>
                    </Collapse>
                 </TableCell>
              </TableRow>   
              <TableRow >  
                <TableCell colSpan={2} component="th" scope="row">
                    <div className='titlePayRollIncidentEnfasis'> {`Comentarios`} </div>
                    <div className='containerTextAreaPayRollInput'> 
                    <TextField
                      id="outlined-multiline-static"   
                      fullWidth                  
                      multiline
                      rows={3}
                      disabled
                      defaultValue={row.Comentarios}
                      variant="standard"
                      InputProps={{                        
                        disableUnderline: true,
                      }}
                    />

                    </div>
               </TableCell>                             
              </TableRow>    
              <TableRow >  
                <TableCell component="th" scope="row"><span className='titlePayRollIncident'> {`Estatus`}</span></TableCell>               
                <TableCell align="right"><EstatusLine row={row}></EstatusLine></TableCell>
             </TableRow>           
        
      </>
    );
  }  

const TableInfoPayRollIncident = ({row}:any) => {


     return (
        <TableContainer >
          <Table aria-label="collapsible table">
           <TableBody>
                <Row key={row.id} row={row} />           
            </TableBody>
          </Table>
        </TableContainer>
      );
}

export default TableInfoPayRollIncident